<template>
  <div class="tab-wrap" v-if="showTab">
    <div class="tab-main-wrap" v-if="mainCardList.length > 1">
      <div
        v-for="(item, index) in mainCardList"
        :key="item.group"
        class="tab"
        :class="{
          active: currentGroup.group === item.group,
          [`${item.page}`]: true,
          'last-active':
            currentGroup.group === item.group &&
            index === mainCardList.length - 1,
          'first-active': currentGroup.group === item.group && index === 0,
        }"
        @click="handleTabClick(item)"
      >
        {{ item.group }}
      </div>
    </div>
    <div
      class="tab-child-wrap"
      :class="{ [`${currentGroup.page}`]: true }"
      v-if="currentGroup.children.length > 1"
    >
      <div
        class="tab-child-item"
        :class="{
          active: currentCard.namespace === item.namespace,
          [`${currentGroup.page}`]: true,
        }"
        v-for="(item, index) in currentGroup.children"
        :key="item.id"
        @click="handleCardClick(item)"
      >
        {{ computedName(item) }}{{ index + 1 }}
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from "@vue/composition-api";

import { useStore } from "@/components/use/base";

export default defineComponent({
  props: [
    "mainCardList",
    "currentGroup",
    "handleCardClick",
    "currentCard",
    "handleTabClick",
  ],
  setup() {
    const store = useStore();
    const namespace = computed(() => store.state.namespace);

    const computedName = computed(() => (item) => {
      if (namespace.value.startsWith("lr")) return "订单";
      return item.card_type_cn;
    });

    const namespaceGroupEn = computed(() => {
      return store.state.namespaceInfo?.namespace_group_en || "";
    });

    const showTab = computed(() => {
      return !["za"].includes(namespaceGroupEn.value);
    });

    return { showTab, computedName };
  },
});
</script>

<style lang="less" scoped>
.tab-wrap {
  .tab-main-wrap {
    width: 100%;
    display: flex;
    height: 27px;
    z-index: 100;
    overflow-x: auto;

    .tab {
      flex: 1;
      box-sizing: border-box;
      min-width: 64px;
      text-align: center;
      background: linear-gradient(98deg, #ffffff 0%, #ebebeb 100%);
      font-size: 12px;
      color: #b3b3b3;
      line-height: 27px;
      text-align: center;
      flex-wrap: nowrap;
      position: relative;
      font-weight: 500;

      &.active {
        &.last-active {
          clip-path: polygon(5% 0, 100% 0, 100% 100%, 0 100%);
        }
        &.first-active {
          clip-path: polygon(0% 0, 95% 0, 100% 100%, 0 100%);
        }
        transform: scaleX(1.1);
        z-index: 1;
        clip-path: polygon(5% 0, 95% 0, 100% 100%, 0 100%);
        color: #ffffff;
        background: linear-gradient(
          134deg,
          #3f3631 0%,
          #211c20 47%,
          #211c20 100%
        );

        &.bjgold {
          color: rgb(74, 41, 9);
          background: linear-gradient(
            135deg,
            #f2e4bf 0%,
            #f9f1db 15%,
            #f1e1b9 49%,
            #f7cfab 100%
          );
        }
        &.bjby {
          color: #4a5f77;
          background: linear-gradient(134deg, #a4b8d1 0%, #bad7f3 100%);
        }
        &.bjbj,
        &.bjbjplus {
          color: rgba(28, 2, 0, 1);
          background: linear-gradient(
            134deg,
            #f9faf4 0%,
            #edc4b5 49%,
            #f3bca1 82%,
            #f9d1bb 100%
          );
        }
        &.bjzs,
        &.bjzsplus {
          color: #332774;
          background: linear-gradient(
            134deg,
            #ecedfe 0%,
            #d79dfd 50%,
            #dbc3ff 100%
          );
        }

        &.bjhj,
        &.bjhjplus {
          color: rgba(234, 239, 244, 1);
          background: linear-gradient(
            134deg,
            #434463 0%,
            #393847 48%,
            #1e1e2a 100%
          );
        }

        &.bjhz,
        &.bjhzplus {
          color: rgba(252, 251, 245, 1);
          background: linear-gradient(
            134deg,
            #3f3631 0%,
            #211c20 47%,
            #211c20 100%
          );
        }
      }
    }
  }

  .tab-child-wrap {
    display: flex;
    align-items: center;
    height: 29px;
    overflow-y: auto;
    box-sizing: border-box;
    background: linear-gradient(134deg, #3f3631 0%, #211c20 47%, #211c20 100%);

    &.bjgold {
      background: linear-gradient(
        135deg,
        #f2e4bf 0%,
        #f9f1db 15%,
        #f1e1b9 49%,
        #f7cfab 100%
      );
    }

    &.bjzs,
    &.bjzsplus {
      background: linear-gradient(
        134deg,
        #ecedfe 0%,
        #d79dfd 50%,
        #dbc3ff 100%
      );
    }

    &.bjby {
      background: linear-gradient(90deg, #a4b8d1 0%, #bad7f3 100%);
    }

    &.bjbj,
    &.bjbjplus {
      background: linear-gradient(
        134deg,
        #f9faf4 0%,
        #edc4b5 49%,
        #f3bca1 82%,
        #f9d1bb 100%
      );
    }

    &.bjhj,
    &.bjhjplus {
      background: linear-gradient(
        134deg,
        #434463 0%,
        #393847 48%,
        #1e1e2a 100%
      );
    }

    &.bjhz,
    &.bjhzplus {
      background: linear-gradient(
        134deg,
        #3f3631 0%,
        #211c20 47%,
        #211c20 100%
      );
    }

    .tab-child-item {
      height: 29px;
      position: relative;
      font-weight: 500;
      font-size: 12px;
      margin: 0 13px;
      line-height: 29px;
      flex-shrink: 0;
      color: rgba(255, 255, 255, 0.6);

      &.active {
        color: #ffffff;
        &::after {
          content: "";
          display: block;
          width: 19px;
          height: 2px;
          background: #ffffff;
          position: absolute;
          left: 50%;
          bottom: 0px;
          transform: translateX(-50%);
        }
      }

      &.bjby {
        color: rgb(132, 154, 180);
        &.active {
          color: #4a5f77;

          &::after {
            background: #526880;
          }
        }
      }

      &.bjgold {
        color: rgba(74, 41, 9, 0.5);
        &.active {
          color: rgb(74, 41, 9);
          &::after {
            background: rgb(74, 41, 9);
          }
        }
      }

      &.bjbj,
      &.bjbjplus {
        color: rgba(28, 2, 0, 0.5);
        &.active {
          color: rgba(28, 2, 0, 1);
          &::after {
            background: rgba(28, 2, 0, 1);
          }
        }
      }

      &.bjhj,
      &.bjhjplus {
        color: rgba(234, 239, 244, 0.5);
        &.active {
          color: rgba(234, 239, 244, 1);
          &::after {
            background: rgba(234, 239, 244, 1);
          }
        }
      }

      &.bjzs,
      &.bjzsplus {
        color: rgba(51, 39, 116, 0.5);
        &.active {
          color: rgba(51, 39, 116, 1);
          &::after {
            background: rgba(51, 39, 116, 1);
          }
        }
      }

      &.bjhz,
      &.bjhzplus {
        color: rgba(252, 251, 245, 0.5);
        &.active {
          color: rgba(252, 251, 245, 1);
          &::after {
            background: rgba(252, 251, 245, 1);
          }
        }
      }
    }
  }
}
</style>
